import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {EnumerationService} from '../enumeration/enumeration.service';
import {FileService} from '../file/file.service';
import {Building} from './building.model';
import {BuildingService} from './building.service';
import {Owner} from '../owner/owner.model';
import {OwnerService} from '../owner/owner.service';
import {CombiFormComponent} from '../shared/combi-form.component';
import {RoutePrefix} from '../shared/route-prefix';
import {TranslateService} from '@ngx-translate/core';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-building-form',
  templateUrl: './building-form.component.html'
})
export class BuildingFormComponent extends CombiFormComponent implements OnInit {
  public building: Building = new Building();
  public owners: Owner[] = [];
  public formTitle: string;
  public floorRoutePrefix: RoutePrefix;
  public countries: string[] = [];
  protected stateIdParam: string = 'buildingId';
  public activeTab: string = (localStorage.getItem('buildingTab')) ? localStorage.getItem('buildingTab') : 'floor';
  public contactRoutePrefix: RoutePrefix;

  constructor(
    protected router: UIRouter,
    protected buildingService: BuildingService,
    protected ownerService: OwnerService,
    protected enumService: EnumerationService,
    private translate: TranslateService,
    private fileService: FileService
  ) {
    super(router);
  }

  public ngOnInit() {
    super.ngOnInit();

    this.enumService.get('country').subscribe((countries: string[]) => {
      this.countries = countries;
    });

    this.ownerService.getAll().subscribe((owners: Owner[]) => {
      this.owners = owners;
    });

    switch(this.formMode) {
      case this.FormMode.ADD : {
        this.translate.get('building.form.add.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;

      case this.FormMode.UPDATE : {
        this.contactRoutePrefix = {entity: Building.name, entityId: this.router.stateService.params.buildingId};

        this.floorRoutePrefix = {
          entity: Building.name.toLowerCase(),
          entityId: this.router.stateService.params.buildingId
        };

        this.buildingService.get(this.router.stateService.params.buildingId).map((building: Building) => {
          if(building.legacyDrawingId) {
            building.setLegacyDrawingSrc(this.fileService.getLinkById(building.legacyDrawingId));
          }
          if(building.notesFileId) {
            building.setNotesFileSrc(this.fileService.getLinkById(building.notesFileId));
          }
          return building;
        }).subscribe((building) => {
          this.building = building;
        });

        this.translate.get('building.form.update.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;
    }
  }

  public onTabSelect(tab) {
    localStorage.setItem('buildingTab', tab);
  }

  public save() {
    switch(this.formMode) {
      case this.FormMode.ADD : {
        this.buildingService.add(this.building).subscribe((response) => {
          const building = new Building();
          building.fromResponse(response);
          this.router.stateService.go('building.edit', {buildingId: building.id}, {reload: true});
        });
      } break;

      case this.FormMode.UPDATE : {
        this.buildingService.update(this.building).subscribe((response) => {
          this.router.stateService.go('building', this.router.stateService.params, {reload: true});
        });
      } break;
    }
  }

  public deleteFile(fileKey: string, fileId: string) {
    this.fileService.deleteById(fileId).subscribe(() => {
      this.building[fileKey] = null;
      this.buildingService.update(this.building).subscribe(() => {
        this.router.stateService.go(this.router.stateService.current.name, this.router.stateService.params, {reload: true});
      });
    });
  }

  public legacyDrawingChange(evt) {
    this.building.setLegacyDrawing(evt.target.files);
  }

  public notesFileChange(evt) {
    this.building.setNotesFile(evt.target.files);
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/building/building-form.component.ts